// Design System Constants - Updated with lime green theme

export const COLORS = {
  // Primary Brand Colors
  primary: '#ccff00', // Vibrant lime green
  primaryDark: '#a8d600',
  primaryLight: '#e0ff66',
  
  // Dark Backgrounds
  background: '#0a0a0a',
  surface: '#121212',
  cardSurface: '#1a1a1a',
  border: '#2a2a2a',
  
  // Complementary Colors
  accent: '#00ffcc', // Cyan accent
  accentPurple: '#cc00ff', // Purple accent for variety
  
  // Text Colors
  text: {
    primary: '#f5f5f5',
    secondary: '#a0a0a0',
    muted: '#707070',
  },
};

export const TYPOGRAPHY = {
  h1: {
    fontSize: '64px',
    lineHeight: '1.1',
    fontWeight: '700',
  },
  h2: {
    fontSize: '48px',
    lineHeight: '1.2',
    fontWeight: '700',
  },
  h3: {
    fontSize: '32px',
    lineHeight: '1.3',
    fontWeight: '600',
  },
  h4: {
    fontSize: '24px',
    lineHeight: '1.4',
    fontWeight: '600',
  },
  bodyLarge: {
    fontSize: '18px',
    lineHeight: '1.6',
    fontWeight: '400',
  },
  body: {
    fontSize: '16px',
    lineHeight: '1.6',
    fontWeight: '400',
  },
  small: {
    fontSize: '14px',
    lineHeight: '1.5',
    fontWeight: '400',
  },
  caption: {
    fontSize: '12px',
    lineHeight: '1.4',
    fontWeight: '500',
  },
};

export const SPACING = {
  xs: '8px',
  sm: '16px',
  md: '24px',
  lg: '32px',
  xl: '48px',
  xxl: '64px',
  xxxl: '96px',
  xxxxl: '128px',
};

export const BORDER_RADIUS = {
  small: '8px',
  medium: '16px',
  large: '24px',
};

export const SHADOWS = {
  card: '0px 8px 24px rgba(0,0,0,0.4)',
  cardHover: '0px 12px 32px rgba(204, 255, 0, 0.2)',
};

export const ANIMATION = {
  timing: 'cubic-bezier(0.4, 0, 0.2, 1)',
  duration: {
    fast: '300ms',
    normal: '500ms',
  },
  stagger: '80ms',
};
